import { PickMaterial } from './PickMaterial';
import { PackMaterial } from './PackMaterial';
import { ShipMaterial } from './ShipMaterial';

export class PickPackShip {
  materialPickedData: PickMaterial[];
  packList: PackMaterial[];
  shipList: ShipMaterial[];
}
